import { styled } from "@mui/material";

export const Content = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: 12,
});

export const Footer = styled("div")({
  display: "flex",
  justifyContent: "space-between",
});
